import { Link } from "react-router-dom";
import { useCategoryName } from "@/i18n";

export default function ProjectCard({ project, index = 0 }) {
  const categoryName = useCategoryName();
  return (
    <Link
      to={`/projeler/${project.slug}`}
      data-testid={`project-card-${project.slug}`}
      className="group block"
    >
      <div className="relative overflow-hidden aspect-[4/3] bg-navy">
        <img
          src={project.cover}
          alt={project.name}
          loading={index < 4 ? "eager" : "lazy"}
          className="h-full w-full object-cover transition-transform duration-[1100ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.07]"
        />
        <span className="absolute inset-0 bg-ink/0 group-hover:bg-ink/10 transition-colors duration-500" />
      </div>
      <div className="pt-4">
        <div className="font-mono text-[10.5px] tracking-[0.16em] uppercase text-slate-400">
          {categoryName(project.category)} · {project.tarih}
        </div>
        <h3 className="font-display text-[18px] leading-snug text-ink mt-1.5 transition-colors duration-300 group-hover:text-brand-blue line-clamp-2">
          {project.name}
        </h3>
      </div>
    </Link>
  );
}
